module.exports = {
      id: "Become_Installer-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/simulator/sprite.svg#Become_Installer-usage",
      toString: function () {
        return this.url;
      }
    }